import { render, staticRenderFns } from "./AverageRevenuePerLearnerPanel.vue?vue&type=template&id=7ba1eac8&scoped=true"
import script from "./AverageRevenuePerLearnerPanel.vue?vue&type=script&lang=js"
export * from "./AverageRevenuePerLearnerPanel.vue?vue&type=script&lang=js"
import style0 from "./AverageRevenuePerLearnerPanel.vue?vue&type=style&index=0&id=7ba1eac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba1eac8",
  null
  
)

export default component.exports